

require('./styles');

var _squid = require('squid');

var _index = require('xo-device-info/dist/index');

define(['squid/index', 'text!./template.html', '../cart/directive', 'components/xo-ui-components/src/escape-hatch/closeFrame/directive', 'components/xo-form-components/src/language-options/directive'], function (squid, template) {
    squid.module('xo-header.directive', ['squid', 'xo-cart.directive', 'xo-escape-hatch.closeFrame.directive', 'xo-language-options.directive']).directive('xoHeader', function () {
        return {
            template: template,
            scope: {
                showCartTotal: '=',
                renderCartContainer: '=',
                token: '=',
                isUnbranded: '=',
                unbrandedTitle: '=',
                unbrandedSubTitle: '=',
                languageSwitch: '=?',
                redirectiframe: '=',
                redirectLightbox: '='
            },
            controller: function controller($scope, $rootScope, $renderContent) {
                $scope.isMessengerBAIntegration = _squid.$integration.getConfig('IS_MESSENGER_BA_INTEGRATION');
                $scope.isMobile = _index.$DeviceInfo.isMobile() || _index.$DeviceInfo.isTablet();
                // $util.assert($scope.token, 'Expected token');
                $scope.title = $renderContent($scope.unbrandedTitle);
                $scope.subTitle = $renderContent($scope.unbrandedSubTitle);
            }
        };
    });
});
_squid.$integration;

_index.$DeviceInfo;


//////////////////
// WEBPACK FOOTER
// ./components/xo-page-components/src/header/directive.js
// module id = ./components/xo-page-components/src/header/directive.js
// module chunks = 1